module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"dialog\" title=\"Confirmation Dialog\" style=\"display: none; font-size: smaller !important;\">\r\n    <div class=\"row\" style=\"padding: 10px 0 10px 15px; width: 100%\">\r\n        <div class=\" col-md-12\">\r\n            Apply permission changes to:\r\n        </div>\r\n    </div>\r\n   \r\n    <div class=\"row\" style=\"padding: 10px 0 0 15px; width: 100%\">\r\n        <div class=\"col-md-2\" style=\"width: 20px;\">\r\n            <input type=\"radio\" name=\"copyPermission\" value='false'  class=\"action-selector\" style=\"margin:0;\"/>\r\n        </div>\r\n        <div class=\" col-md-10\">\r\n            Connection Only\r\n        </div>\r\n    </div>\r\n    <div class=\"row\" style=\"padding: 5px 0 0 15px; width: 100%\">\r\n        <div class=\"col-md-2\" style=\"width: 20px;\">\r\n            <input type=\"radio\" name=\"copyPermission\" value='true' class=\"action-selector\" style=\"margin:0;\"/>\r\n        </div>\r\n        <div class=\" col-md-10\">\r\n            Connection including Actions\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}